import type { HubOneOfCameraExampleStreamTriggermode } from '@robovision/hub'


export enum TriggerMode {
  ApiSignal = 'ApiSignal',
  CameraConfig = 'CameraConfig',
  ExternalTrigger = 'ExternalTrigger', // TODO: not supported yet
  Interval = 'Interval', // TODO: not supported yet
}

export function triggerModeToHubTriggerMode (triggerMode: TriggerMode): HubOneOfCameraExampleStreamTriggermode {
  switch (triggerMode) {
    case TriggerMode.ApiSignal:
      return { kind: 'HTTP' }
    case TriggerMode.CameraConfig:
      return { kind: 'CONFIG' }
    default:
      throw new Error(`Trigger mode ${triggerMode} is not supported`)
  }
}

export function hubTriggerModeToTriggerMode (hubTriggerMode: HubOneOfCameraExampleStreamTriggermode): TriggerMode {
  switch (hubTriggerMode.kind) {
    case 'HTTP':
      return TriggerMode.ApiSignal
    case 'CONFIG':
      return TriggerMode.CameraConfig
    default:
      throw new Error(`Hub trigger mode ${hubTriggerMode.kind} is not supported`)
  }
}
